var cloneSvg = function cloneSvg(sourceSvg) {
  return sourceSvg.cloneNode(true);
};

export default cloneSvg;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@tanem/svg-injector/esm/clone-svg.js
// module id = 140
// module chunks = 0